import React, { FC } from 'react';
import Button, { ButtonIntentE } from '../../components/Button/Button';
import { isMobileOrTablet } from '../../utils/helpers/mediaQueries';
import { WizardModeE } from './models';

import styles from './styles.module.scss';

type CampaignWizardFooterPropTypes = {
    mode: WizardModeE;
}

// spec 48 — every submit here acts on the Campaign, so all three carry the campaign intent.
const CampaignWizardFooter: FC<CampaignWizardFooterPropTypes> = (props) => {
    const { mode } = props;

    return (
        <div className={styles.wizardFooter}>
            <span/>
            {mode === WizardModeE.Create && (
                <Button form='create-campaign' intent={ButtonIntentE.CAMPAIGN} useGlobalLoading>Create a new campaign</Button>
            )}
            {mode === WizardModeE.Edit && (
                <Button useGlobalLoading form='create-campaign' intent={ButtonIntentE.CAMPAIGN}>Save changes</Button>
            )}
            {mode === WizardModeE.Clone && (
                <Button useGlobalLoading form='create-campaign' intent={ButtonIntentE.CAMPAIGN}>{isMobileOrTablet() ? 'Clone campaign mobile' : 'Clone campaign'}</Button>
            )}
        </div>
    );
};

export default CampaignWizardFooter;